import React, { Component, PropTypes } from 'react';
import ActionCreators from 'actions/ActionCreators';
import Button from 'components/ButtonControl';
import EditingCargoStore from 'stores/EditingCargoStore';
import CategoryStore from 'stores/CategoryStore';
import CargosStore from 'stores/CargosStore';
import InlineSVG from 'svg-inline-react';
import ShallowCompare from 'react-addons-shallow-compare';
import { translate as t } from 'lang';
import { sendCargoPhoto } from 'api';
import config from '../../../configs/application';

import './CargoPhotoControl.scss';

const SPINNER_PATH = config.static.root + '/spinner/spinner.svg';

class CargoPhotoControl extends Component {

    static propTypes = {
        photo: PropTypes.array
    }

    constructor(props) {
        super(props);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return ShallowCompare(this, nextProps, nextState);
    }

    onClick = () => {
        this.refs['fileInput'].click();
    }

    onFileSelect = (e) => {
        e.preventDefault();

        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        } else if (e.target) {
            files = e.target.files;
        }

        if (!files || files.length != 1) {
            return;
        }

        const file = files[0];

        // 10485760 - bytes in 10 megabytes
        if (file.size > 10485760) {
            alert(t('PHOTO_SIZE_LIMIT_EXCEEDED'));
            return;
        }

        if (!/\.(jpg|jpeg|png)$/i.test(file.name)) {
            alert(t('PHOTO_WRONG_FORMAT'));
            return;
        }

        this.showSpinner();
        this.uploadPhoto(file);
    }

    showSpinner = () => {
        let photo = EditingCargoStore.getEditingCargo().getIn(['attributes', 'photo', 'value']);
        let list = [];

        if (!photo) photo = [];

        for (let i = 0; i < photo.length; i++) list.push(photo[i]);
        list.push(SPINNER_PATH);
        ActionCreators.updateEditingCargo({
            photo: list
        });
    }

    uploadPhoto = (file) => {
        const categoryId = CategoryStore.getSelected().get('intId');
        const photos = EditingCargoStore.getEditingCargo().getIn(['attributes', 'photo', 'value']);
        let cargoIndex = CargosStore.getCargoIndex();
        let photoIndex = 0;

        if (cargoIndex === -1) {
            cargoIndex = CargosStore.getDeliveryCargos().size;
        }

        if (photos) {
            photoIndex = photos.length-1;
        }

        let request = new FormData();
        request.append(`order[${cargoIndex}][${categoryId}][${photoIndex}]`, file);

        sendCargoPhoto(request).then((result) => {
            const photo = EditingCargoStore.getEditingCargo().getIn(['attributes', 'photo', 'value']);
            const list = photo.map((item, index) => {
                if (index === photo.length - 1 && item === SPINNER_PATH) {
                    item = result.preview;
                }
                return item;
            });

            ActionCreators.updateEditingCargo({
                photo: list
            });
        });
    }

    render() {
        return (
            <Button className="CargoPhotoControl" view="stone" onClick={ this.onClick }>
                <input ref="fileInput" type="file" value={''} multiple={ false } accept='image/png,image/jpeg,image/jpg' onChange={ this.onFileSelect } style={{ display: 'none' }}/>
                <div className="CargoPhotoControl__icon"><InlineSVG src={require("!svg-inline!./add_photo_icon.svg")}/></div>
                <span className="CargoPhotoControl-title">Добавить фото</span>
                <div className="CargoPhotoControl-label">.jpg, .png не более 10 Мб</div>
            </Button>
        );
    }
}

export default CargoPhotoControl;



// WEBPACK FOOTER //
// ./client/components/CargoPhotoControl/CargoPhotoControl.js